/**
 * True when the site runs inside a native app WebView or in-app browser (not desktop Chrome).
 * Used for compact UI (e.g. cookie banner) where bottom nav may be absent.
 */
export function isInAppWebView() {
  if (typeof window === 'undefined') return false;

  const params = new URLSearchParams(window.location.search);
  if (params.get('webview') === '1' || params.get('in_app') === '1' || params.get('app') === '1') {
    return true;
  }

  if (window.ReactNativeWebView) return true;

  const ua = String(navigator.userAgent || '');
  return /; wv\)|\bWebView\b|FB_IAB|FBAN|FBAV|Instagram|Line\/|Twitter|GSA\/|DaivBharathi|daivbharathi/i.test(
    ua,
  );
}
